import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vSelect from 'vue-select';

export default Vue.component('dynamic-multi-select', {
  template: require('./template.html'),
  name: 'dynamic-multi-select',
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
    'all-categories',
  ],
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
    groups() {
      return this.currentSite.dynamic[this.activeSiteType].groups || [];
    },
    options() {
      let options = this.allCategories;
      if (this.type === 'groups' && this.groups) {
        const groups = _.cloneDeep(this.groups);
        options = groups.map(g => g.alias);
      }
      return options;
    },
  },
  data() {
    return {
      display: {
        selectedItems: [],
      },
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      let val;
      if (this.type === 'groups') {
        const selected = _.filter(
          this.groups, g => _.find(this.activeItem[this.type], name => g.name === name),
        );
        val = _.map(selected, g => g.alias);
      } else {
        val = this.activeItem[this.type];
      }
      this.display.selectedItems = _.cloneDeep(val);
    },
    updateCategories(val) {
      if (this.innerTabs[this.dynamicTab]) {
        // when attaching items to groups, we need to go and add the _id's to the groups
        let list = _.cloneDeep(val);
        if (this.type === 'groups') {
          const chosen = _.filter(this.groups, g => _.find(val, v => v === g.alias));
          list = _.cloneDeep(_.map(chosen, c => c.name));
          _.forEachRight(this.groups, (group) => {
            if (list.includes(group.name) && !group.items.includes(this.activeItem._id)) {
              // add item to groups
              this.$store.dispatch('pushDropletVal', {
                array: group.items,
                val: this.activeItem._id,
              });
            }
            // if doesn't include it and it
            const index = _.findIndex(group.items, _id => this.activeItem._id === _id);
            if (index > -1 && !list.includes(group.name)) {
              // remove item from globals
              this.$store.dispatch('spliceDropletVal', {
                array: group.items,
                index,
              });
            }
          });
        }
        this.$store.dispatch('setDropletVal', {
          drp: this.activeItem,
          key: this.type,
          val: list,
        });
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/multi-select/index.js